<template>
  <div class="case-detail-gene-hgmd-data-page col-block width-full" :style="{ flex: 1 }">
    <div class="data-container col-block width-full" v-for="(variant, vkey) in variants" :key="vkey">
      <div class="data-title-container row-block">
        <div class="data-title">{{ variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -' }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="data-content-container col-block width-full">
        <div class="data-content-block col-block width-full" v-for="(optionGroup, gindex) in tableOptionGroups" :key="gindex">
          <div class="data-row-container col-block width-full">
            <div class="data-row row-block stretch">
              <div class="data-col col-block" v-for="(option, oindex) in optionGroup.options" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
                <div :style="{ flex: 1 }"></div>
                <div class="data-content" v-html="option.title"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
            <div class="data-row row-block stretch" v-for="(hgmdData, hindex) in hgmdDataMaps[vkey]" :key="hindex">
              <div class="data-col col-block" v-for="(option, oindex) in optionGroup.options" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
                <div :style="{ flex: 1 }"></div>
                <div class="data-content" :style="option.color ? { color: option.color(hgmdData) } : {}" v-html="option.value(hgmdData) || option.empty || '- -'"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: 0 }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { defaultEmptyDisplay } from '../../constants/global/data'

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    },
    hgmdDataMaps () {
      let hgmdKeys = [
        'hgmd_gene',
        'hgmd_hgvs_c',
        'hgmd_hgvs_p',
        'hgmd_disease',
        'hgmd_class',
        'hgmd_accession',
        'hgmd_pmid'
      ]
      return Object.keys(this.variants).reduce((map, vkey) => {
        let variant = this.variants[vkey]
        let hgmdDatas = hgmdKeys.reduce((map, key) => ({ ...map, [key]: (variant[key] || '').split('|') }), {})
        return {
          ...map,
          [vkey]: hgmdDatas[hgmdKeys[0]].map((_, index) => hgmdKeys.reduce((data, key) => ({ ...data, [key]: hgmdDatas[key][index] }), {}))
        }
      }, {})
    },
    // static
    tableOptionGroups () {
      const clinvar = {
        title: this.$t('COMPONENT.caseDetail.geneHGMDData.table.hgmd.___title'),
        options: [
          {
            title: this.$t('COMPONENT.caseDetail.geneHGMDData.table.hgmd.title.___gene'),
            value: data => data.hgmd_gene,
            color: null,
            width: null,
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneHGMDData.table.hgmd.title.___hgvsc'),
            value: data => data.hgmd_hgvs_c,
            color: null,
            width: null,
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneHGMDData.table.hgmd.title.___hgvsp'),
            value: data => data.hgmd_hgvs_p,
            color: null,
            width: null,
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneHGMDData.table.hgmd.title.___disease'),
            value: data => data.hgmd_disease,
            color: null,
            width: null,
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneHGMDData.table.hgmd.title.___class'),
            value: data => data.hgmd_class,
            color: null,
            width: null,
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneHGMDData.table.hgmd.title.___accession'),
            value: data => data.hgmd_accession,
            color: null,
            width: null,
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneHGMDData.table.hgmd.title.___pmid'),
            value: data => data.hgmd_pmid,
            color: null,
            width: null,
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          }
        ]
      }
      return [
        clinvar
      ].filter(x => x)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/caseDetail/geneHGMDData.vue